import React from "react"
import PropTypes from "prop-types"
import axios from "axios"
import AppStore from "../AppStore"
import {observer} from "mobx-react"
import { HashRouter as Router, Route, Link } from "react-router-dom";

@observer
class CheckBien extends React.Component {
  updateList(){
    axios.get("/api/v1/experts/app/pieces/"+AppStore.rdv.id,{}).then((data)=>{
      this.setState({pieces: data.data})
    })
  }
  constructor(props) {
    super(props);
    this.handleChangeQuantite = this.handleChangeQuantite.bind(this)
    this.showForm = this.showForm.bind(this)
    this.ajouterPiece = this.ajouterPiece.bind(this)
    this.handleAddPiece = this.handleAddPiece.bind(this)
    this.updateList = this.updateList.bind(this)
    this.state = {
      pieces: [],
      addPiece: false,
      piecesPossible: [],
      quantite:  1,
      pieceAjoute: ""
    };
    this.updateList()

  }
  handleAddPiece(e){
    e.preventDefault()
    axios.post("/api/v1/experts/app/addPiece",{id: AppStore.rdv.id,piece: this.state.pieceAjoute,quantite: this.state.quantite}).then((data)=>{
      this.updateList()
      this.setState({quantite: 1,addPiece: false,pieceAjoute: ""})
    })
  }
  handleChangeQuantite(e){
    let idPiece = e.target.dataset.piece
    let val = e.target.value
    let index = e.target.dataset.index
    axios.post("/api/v1/experts/app/updateQuantitePiece",{id: AppStore.rdv.id,piece: idPiece,quantite: val}).then((data)=>{
      console.log(data.data)
      let pieces = this.state.pieces
      pieces[index][1] = val
      this.setState({pieces: pieces})
    })
  }
  ajouterPiece(){
    if(this.state.addPiece){
      return(
          <div className="row">
              <div className="input-field col s4">
                <select className="browser-default" value={this.state.pieceAjoute} onChange={(e)=>this.setState({pieceAjoute: e.target.value})} name="" id="">
                  <option value="" disabled>Piece</option>
                  {this.state.piecesPossible.map((type,index)=>(
                      <option key={index} value={type.id}>{type.titre}</option>
                    ))}
                </select>
              </div>
              <div className="input-field col s4">
                <select name=""  onChange={(e) => this.setState({quantite: e.target.value})} value={this.state.quantite} className="browser-default"  id="">
                    <option value="" disabled>Quantité</option>
                    {[...Array(10)].map((x,i)=>(
                      <option key={i} value={i}>{i}</option>
                      ))}
                  </select>
              </div>
              <div className="input-field col s4">
                  {this.state.pieceAjoute=="" ? (
                      <div></div>
                    ) : (
                      <a href="" onClick={this.handleAddPiece} className="btn"><i className="material-icons left">add</i>Ajouter</a>
                    )}
              </div>
          </div>
        )
    }else{
      return(
          <p><a href="" onClick={this.showForm} className="btn">Ajouter une piece</a></p>

        )
    }
  }
  showForm(e){
    e.preventDefault()
    axios.get("/api/v1/gettypesdepieces",{}).then((data)=>{
      console.log(data.data)
      this.setState({piecesPossible: data.data})
    })
    this.setState({addPiece: true})
  }
  render () {
    return (
      <React.Fragment>
        <h1 className="center">Vérification du bien</h1>
        {AppStore.bien.controle ? (
          <div>
          <p>Le bien a déjà été controlé, vous pouvez continuer</p>
          </div>
          ) : (
          <div className="row container">
          {this.ajouterPiece()}
            {this.state.pieces.map((piece,index)=>(
              <div className="row" key={index} >
                <div className="col s4">
                  <p>{piece[0].titre}</p>
                </div>
                <div className="input-field col s4">
                  <select name="" onChange={this.handleChangeQuantite} className="browser-default" data-index={index} value={piece[1]} data-piece={piece[0].id} data-quantite={piece[1]} id="">
                    <option value="" disabled>nombre de {piece[0].titre}</option>
                    {[...Array(10)].map((x,i)=>(
                      <option key={i} value={i}>{i}</option>
                      ))}
                  </select>
                </div>
              </div>
              ))}
            <div className="row">
              <Link className="btn btn-large" to="/representants">Valider</Link>
            </div>
          </div>
          )}
      </React.Fragment>
    );
  }
}

export default CheckBien
